// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3kJUb","modalFooterButton":"ModalNotes_modalFooterButton__2q433"};